module.exports = __webpack_public_path__ + "static/media/pulldown.57a81b82.svg";